import type { User } from '@rhythmic/db/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRhythmicLogger } from '#imports'

import { mutators as teamMutators } from './mutators'
import useTeamContextQueries from './useTeamContext.queries'

export const useTeamContext = defineStore('team-context', () => {
  const logger = useRhythmicLogger('teamContextStore')

  const queries = useTeamContextQueries()
  queries.init({ logger })

  const members = ref<User[]>([])
  const isLoading = ref(false)
  const isReady = ref(true)

  const mutators = teamMutators.init({
    logger,
    workspaceId: queries.workspaceId,
    workspaceSlug: queries.workspaceSlug,
    teams: queries.teams,
    team: queries.team,
  })

  return {
    queries,
    workspaceSlug: queries.workspaceSlug,
    teamSlug: queries.teamSlug,
    harmonyPlanId: queries.harmonyPlanId,
    // organizationId,
    // organizationIsLoading,
    workspace: queries.workspace,
    workspaceId: queries.workspaceId,
    workspaceMembers: queries.workspaceMembers,
    teamMembers: queries.teamMembers,
    teamReferenceStories: queries.teamReferenceStories,
    teams: queries.teams,
    team: queries.team,
    tags: queries.tags,
    workitemTags: queries.workitemTags,
    harmonyPlans: queries.harmonyPlans,
    harmonyPlan: queries.harmonyPlan,
    filteredTeamWorkspaceMembers: queries.filteredTeamWorkspaceMembers,
    members,
    iterations: queries.iterations,
    workitems: queries.workitems,
    isLoading,
    isReady,
    isLoadingWorkspace: queries.isLoadingWorkspace,
    isLoadingPlans: queries.isLoadingPlans,
    isLoadingTeams: queries.isLoadingTeams,
    isLoadingWorkitems: queries.isLoadingWorkitems,
    ...mutators,
  }
})

export default useTeamContext
